module.exports = __webpack_public_path__ + "static/macworld_logo_shadowed-89f40dcff2bde082d080257b1b47637b.png";